export const BaseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:4200';
